import { ActivityIndicator } from 'react-native'
import { useRefreshVariants } from './hooks'
import type { TRefreshProps } from './types'

export const Refresh = ({ color, size, testID }: TRefreshProps) => {
  const { refreshSizeMapping, refreshColorMapping } = useRefreshVariants()

  return (
    <ActivityIndicator
      color={refreshColorMapping[color]}
      size={refreshSizeMapping[size]}
      testID={testID}
    />
  )
}

export type { TRefreshProps }
